import { render, staticRenderFns } from "./safesDeposits.vue?vue&type=template&id=1ce39a67"
import script from "./safesDeposits.vue?vue&type=script&lang=js"
export * from "./safesDeposits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports